import CollectionPage from '~/components/module/setup/CollectionPage';
import { setupRouteAbsolute } from '~/utils/routes/setup';
import { createPersonAdapter } from '~/apis/personList';
import { ADDRESS_FIELDS } from '~/utils/helper/setupForm';
import { DEFAULT_DIAL_CODE } from '~/utils/constants/countries';
import { fullName, joinParts, str } from '~/components/module/setup/cells';
import { IFormField } from '~/utils/interface/setup';

const adapter = createPersonAdapter('doctor-contacts', 'type');

const fields: IFormField[] = [
  { name: 'firstName', labelKey: 'pages.setup.fields.firstName', type: 'text', required: true },
  { name: 'lastName', labelKey: 'pages.setup.fields.lastName', type: 'text', required: true },
  { name: 'type', labelKey: 'pages.setup.doctorContacts.type', type: 'text', required: true },
  { name: 'phoneNumber', labelKey: 'pages.setup.fields.phoneNumber', type: 'phone', countryName: 'countryCode', required: true },
  ...ADDRESS_FIELDS,
];

const DoctorContacts = () => (
  <CollectionPage
    i18nPrefix='pages.setup.doctorContacts'
    module='seniorMedical'
    permissionAction='manageDoctorContact'
    backTo={{ path: setupRouteAbsolute.medical, labelKey: 'nav.setup.medical' }}
    adapter={adapter}
    fields={fields}
    defaultForm={{ countryCode: DEFAULT_DIAL_CODE }}
    getTitle={fullName}
    columns={[
      { key: 'name', labelKey: 'pages.setup.table.name', render: (form) => <span className='font-medium text-foreground'>{fullName(form)}</span> },
      { key: 'type', labelKey: 'pages.setup.doctorContacts.type', render: (form) => str(form.type) },
      {
        key: 'phone',
        labelKey: 'pages.setup.fields.phoneNumber',
        render: (form) => joinParts([form.countryCode, form.phoneNumber], ' '),
      },
      {
        key: 'address',
        labelKey: 'pages.setup.fields.address',
        render: (form) => joinParts([form.address, form.city, form.country]),
      },
    ]}
  />
);

export default DoctorContacts;
